/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Feature_Starter_7Inputs */



/**
* | output |
* | --- |
* | "Video export with burnt-in subtitles" |
*
* @param {Signup_Feature_Starter_7Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_feature_starter_7 = /** @type {((inputs?: Signup_Feature_Starter_7Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Feature_Starter_7Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Video export with burnt-in subtitles")
	if (locale === "de") return /** @type {LocalizedString} */ ("Video export with burnt-in subtitles")
	if (locale === "it") return /** @type {LocalizedString} */ ("Video export with burnt-in subtitles")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Video export with burnt-in subtitles")
	if (locale === "es") return /** @type {LocalizedString} */ ("Video export with burnt-in subtitles")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Video export with burnt-in subtitles")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Video export with burnt-in subtitles")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Video export with burnt-in subtitles")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Video export with burnt-in subtitles")
	return /** @type {LocalizedString} */ ("Video export with burnt-in subtitles")
});